import { render, staticRenderFns } from "./Buildings.vue?vue&type=template&id=e968db64&scoped=true"
import script from "./Buildings.vue?vue&type=script&lang=js"
export * from "./Buildings.vue?vue&type=script&lang=js"
import style0 from "./Buildings.vue?vue&type=style&index=0&id=e968db64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e968db64",
  null
  
)

export default component.exports